<ng-container *ngFor="let segment of segments">
    <mark *ngIf="segment.toLowerCase() === needle?.toLowerCase(); else notMarked">{{segment}}</mark>
    <ng-template #notMarked>{{segment}}</ng-template>
</ng-container>
